import { FC } from 'react'

import { Row } from '@/shared/ui/Grid'

import { GiftBenefit } from '../GiftBenefit/GiftBenefit'

export type GiftBenefitsListProps = {
	items: {
		title: string
		description: string
		imgSrc: string
	}[]
}

/**
 * List of benefits
 * @param props
 * @param props.items array of benefits
 */

export const GiftBenefitsList: FC<GiftBenefitsListProps> = ({ items }) => (
	<Row gutter={[20, 20]}>
		{items.map(({ title, description, imgSrc }) => (
			<GiftBenefit description={description} key={title} title={title} imgSrc={imgSrc} />
		))}
	</Row>
)
